import { Api } from '@/api'

const state = {
  jobSence: 1, // 新建职位场景
  recruitType: '', // 招聘类别
  sysJobConfig: null // 职位管理配置
}
const mutations = {
  // 新建职位场景
  setJobSence: (state, val) => {
    state.jobSence = val
  },
  setRecruitType: (state, val) => {
    console.log(val, 'change setRecruitType')
    state.recruitType = val
  },
  setSysJobConfig: (state, val) => {
    state.sysJobConfig = val
  }
}
const actions = {
  // 获取职位管理设置-(是否开启发起审批)
  getSysJobConfigDetail: function({ commit }) {
    return new Promise((resolve, reject) => {
      Api.sysConfigDetail({ type: 22 }).then(res => {
        if (res.code === '0') {
          // commit('setSysJobConfig', {
          //   jobApprovalswitch: 1,
          //   approvalType: 1
          // })
          commit('setSysJobConfig', res.data?.rule)
          resolve(res.data)
        } else {
          commit('setSysJobConfig', [])
          if (res.code === '600666') return
          reject(res)
        }
      }).catch(err => { 
        if (err.code === '600666') return
        reject(err) })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}

